import { partnerApi, type ApiResponse } from '../../lib/api';

export const AGENTS_PAGE_SIZE = 25;

export interface PartnerAgent {
  id: string;
  type: 'voice' | 'generic';
  tenantName: string;
  tenantExternalId: string;
  tools: string[];
}

export interface AgentsListResult {
  agents: PartnerAgent[];
  pagination: { hasNextPage: boolean; cursor?: string | null };
}

export async function fetchAgentsPage(cursor?: string): Promise<AgentsListResult> {
  const params = new URLSearchParams({ limit: String(AGENTS_PAGE_SIZE) });
  if (cursor) {
    params.set('cursor', cursor);
  }
  const response = await partnerApi.request<ApiResponse<AgentsListResult>>(`/partner/agents?${params}`);
  return response.data;
}
